import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { paths } from '@src/routes/paths';
import { LoadingScreen } from '@syntra/ui/components/loading-screen';

import DashboardLayout from 'src/layouts/dashboard';
import { FeatureFlag } from 'src/auth/feature-flags';
import { AuthGuard, OnboardingGuard } from 'src/auth/guard';
import FeatureFlagGuard from 'src/auth/guard/feature-flag-guard';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('../pages/CompanyPartnerIndexPage'));
const CreatePage = lazy(() => import('../pages/CompanyPartnerCreatePage'));
const EditPage = lazy(() => import('../pages/CompanyPartnerEditPage'));

// ----------------------------------------------------------------------
export const companyPartnerRoutes = [
  {
    path: `${paths.dashboard.company_partner.index}`,
    element: (
      <AuthGuard>
        <OnboardingGuard>
          <FeatureFlagGuard flag={FeatureFlag.CompanyPartners}>
            <DashboardLayout>
              <Suspense fallback={<LoadingScreen />}>
                <Outlet />
              </Suspense>
            </DashboardLayout>
          </FeatureFlagGuard>
        </OnboardingGuard>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'create', element: <CreatePage /> },
      { path: 'edit/:id', element: <EditPage /> },
    ],
  },
];
